import { render } from "./DetailStatusList.vue?vue&type=template&id=b124b828&scoped=true"
import script from "./DetailStatusList.vue?vue&type=script&lang=js"
export * from "./DetailStatusList.vue?vue&type=script&lang=js"

import "./DetailStatusList.vue?vue&type=style&index=0&id=b124b828&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b124b828"

export default script